---
date: 2021-12-09
title: Preview your changes
---


You can now preview your changes on indoor= before sending them to OpenStreetMap. Read the [blog post](https://2metz.fr/blog/indoorequal-preview-geojson/).
